import React from "react";
import { Box, Grid, Paper, Stack, Typography } from "convertupleads-theme";
import OutlinedButtonMedium from "./OutlinedBtnComponents/OutlinedButtonMedium";
import OutlinedLoadingButton from "./OutlinedBtnComponents/OutlinedLoadingButton";
import OutlinedBtnWithIcons from "./OutlinedBtnComponents/OutlinedBtnWithIcons";
import OutlinedButtonWithStartIcon from "./OutlinedBtnComponents/OutlinedButtonWithStartIcon";
import OutlinedButtonDisabled from "./OutlinedBtnComponents/OutlinedButtonDisabled";
import OutlinedButtonSmall from "./OutlinedBtnComponents/OutlinedButtonSmall";
import OutlinedButtonLarge from "./OutlinedBtnComponents/OutlinedButtonLarge";
import OutlinedButtonWithEndIcon from "./OutlinedBtnComponents/OutlinedButtonWithEndIcon";

const OutlinedButtons = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Outlined Button
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          this is the button with border style.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Grid container rowSpacing={2} columnSpacing={2}>
          <Grid item xs={6}>
            <OutlinedButtonLarge />
          </Grid>
          <Grid item xs={6}>
            <OutlinedButtonMedium />
          </Grid>
          <Grid item xs={6}>
            <OutlinedButtonSmall />
          </Grid>
          <Grid item xs={6}>
            <OutlinedButtonDisabled />
          </Grid>
          <Grid item xs={6}>
            <OutlinedButtonWithStartIcon />
          </Grid>
          <Grid item xs={6}>
            <OutlinedButtonWithEndIcon />
          </Grid>
          <Grid item xs={6}>
            <OutlinedBtnWithIcons />
          </Grid>
          <Grid item xs={6}>
            <OutlinedLoadingButton />
          </Grid>
        </Grid>
      </Paper>
    </Stack>
  );
};

export default OutlinedButtons;
